import Phaser from "phaser";
import { BootScene } from "./game/scenes/BootScene";
import { StartScene } from "./game/scenes/StartScene";
import { BoardScene } from "./game/scenes/BoardScene";
import { BattleScene } from "./game/scenes/BattleScene";
import { LobbyScene } from "./game/scenes/LobbyScene";
import { isArtLayoutCapture } from "./artLayout";
import { STAGE } from "./game/view/stage";
import { installOnlineOverlay } from "./game/view/OnlineOverlay";
import { multiplayer } from "./game/multiplayer";
import { setGameStatus } from "./game/status";
import { followCanvasLayout } from "./game/view/browserLayout";

// Phaser presents the action; the plain TypeScript model owns the outcome.
const game = new Phaser.Game({
  type: Phaser.AUTO,
  parent: "phaser-root",
  width: STAGE.width,
  height: STAGE.height,
  backgroundColor: isArtLayoutCapture ? "rgba(0,0,0,0)" : "#17283a",
  scene: [BootScene, StartScene, LobbyScene, BoardScene, BattleScene],
  // Safari owns gestures. Its mouse events from a completed tap still reach Phaser.
  input: { touch: false, mouse: { preventDefaultWheel: false } },
  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH,
  },
  render: {
    antialias: true,
    transparent: isArtLayoutCapture,
  },
});

game.events.once(Phaser.Core.Events.READY, () => followCanvasLayout(game));
installOnlineOverlay();
function showMenu(scene: string, data?: object): void {
  for (const active of game.scene.getScenes(true)) active.scene.stop();
  game.scene.start(scene, data);
}
window.addEventListener("mergeborn-leave-match", () => showMenu("StartScene", { menu: true }));
multiplayer.subscribe(event => { if (event.type === "left") showMenu("LobbyScene"); });
window.addEventListener("error", event => setGameStatus("error", `Game error: ${event.message}`));
window.addEventListener("unhandledrejection", event => setGameStatus("error", `Game error: ${event.reason instanceof Error ? event.reason.message : String(event.reason)}`));
